<template>

  <div class="container">
    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">客户姓名:</span>
          <!-- 搜索客户姓名-->
          <el-input
            v-model="search_data.name"
            placeholder="请输入客户姓名 "
            class="handle-input mr10"
            @keyup.enter.native="searchConsumerRecordLists"
          ></el-input>
        </el-col>

        <el-col :span="16">

          <span class="title">起止时间:</span>

          <el-date-picker
            v-model="search_time"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="timeChange"
            style="width: 350px;"
          >
          </el-date-picker>
        </el-col>

      </el-row>

      <el-row class="head-search">
        <el-col :span="8">

          <span class="title">手机号码:</span>
          <!-- 搜索手机号码 -->
          <el-input
            v-model="search_data.phone"
            placeholder="请输入手机号码"
            class="handle-input mr10"
            maxlength="11"
            @keyup.enter.native="searchConsumerRecordLists"
          ></el-input>
        </el-col>

      </el-row>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchConsumerRecordLists"
      >搜索</el-button>
      <el-button
        icon="el-icon-refresh-right"
        @click="refresh"
      >刷新</el-button>

    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
      @selection-change="handleSelectionChange"
    >

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
          >

            <div class="more-style">

              <el-form-item label="记录时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

            </div>

          </el-form>
        </template>
      </el-table-column>

      <el-table-column
        prop="id"
        label="id"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="consumer.name"
        label="客户姓名"
        min-width="150"
      >
      </el-table-column>

      <el-table-column
        prop="consumer.phone"
        label="电话"
        min-width="150"
      >
      </el-table-column>

      <el-table-column
        prop="consumer.city.name"
        label="所属城市"
        min-width="150"
      >
      </el-table-column>

      <el-table-column
        prop="mode.alias"
        label="账本模式"
        min-width="150"
      >
      </el-table-column>

      <el-table-column
        prop="operation.alias"
        label="账户操作"
        min-width="150"
      >
      </el-table-column>

      <el-table-column
        prop="amount"
        label="金额"
        min-width="100"
      >
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages
        :search_data="search_data"
        :result_data="result_data"
        @pages_function="pages_function"
      ></pages>
    </div>

  </div>

</template>

<script>
var _this;
import bus from '../../common/bus.js';

export default {
    data() {
        return {
            search_time: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                fixed_array: '',
                phone: '',
                name: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.consumerRecordLists();

        // 接收子组件传来的事件并初始化列表
        bus.$on('onSubmit', (msg) => {
            _this.consumerRecordLists();
        });
    },

    methods: {
        timeChange(val) {
            if (val !== null) {
                _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        searchConsumerRecordLists() {
            _this.search_data.page = 1;
            _this.consumerRecordLists();
        },

        consumerRecordLists() {
            _this
                .$post('/consumer/consumerRecordLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            console.log(_this.search_data);

            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.consumerRecordLists();
        },
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>